import { jsx as _jsx } from "react/jsx-runtime";
import { Link as ChakraLink, } from '@chakra-ui/react';
/**
 * Links are accessible elements used primarily for navigation.
 * Can be integrated with other routing libraries like React Router and Reach Router
 * using the 'as' property. See docs for examples.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/link
 * @see WAI-ARIA https://www.w3.org/WAI/ARIA/apg/patterns/link/
 */
export function Link({ children, ...props }) {
    return _jsx(ChakraLink, { ...props, children: children });
}
//# sourceMappingURL=link.js.map